<template>
  <v-progress-circular size="16" width="2" indeterminate :color="color" />
</template>

<script>
export default {
  name: "SmallSpinner",
  props: {
    color: {
      type: String,
      required: false,
      default: undefined,
    },
  },
};
</script>

<style scoped></style>
